import * as React from 'react';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import Typography from '@mui/material/Typography';
import { Box, Button, Grid, Stack, Card, CardMedia, CardActionArea, Backdrop,CircularProgress } from '@mui/material';
import Carousel from 'react-material-ui-carousel'
import Link from '@mui/material/Link';
import { useNavigate } from 'react-router-dom';
const API = require("../../data/network/API");



export default function Home() {
  const navigate = useNavigate();

  const [rows, setRows] = React.useState([]);
  const [quizzes, setQuizzes] = React.useState([]);
  const [polls, setPolls] = React.useState([]);
  const [roulettes, setRoulettes] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [campaign, setCampaign] = React.useState(false);



  const getQuizzes = async (firestore_id) => {
    setOpen(true)
    const queryParams = {
      'id_campaña': firestore_id, 
      estatus:true
    }
    const response = await API.getQuizzes(queryParams)
    setOpen(false)
    if(response.status == 200){
      console.log(response.data)
      setQuizzes(response.data)
    }else{

    }
  }

  const getPolls= async (firestore_id) => {
    setOpen(true)
    const queryParams = {
      'id_campaña': firestore_id, 
      estatus:true
    }
    const response = await API.getPolls(queryParams)
    setOpen(false)
    if(response.status == 200){
      console.log(response.data)
      setPolls(response.data)
    }else{

    }
  }

  const getRoulettes = async (firestore_id) => {
    setOpen(true)
    const queryParams = {
      'id_campaña': firestore_id, 
      estatus:true
    }
    const response = await API.getRoulettes(queryParams)
    setOpen(false)
    if(response.status == 200){
      console.log(response.data)
      setRoulettes(response.data)
    }else{

    }
  }

  const getCampaigns = async () => {
    setOpen(true)
    const signin_data = localStorage.getItem("signin-data");
    const data = JSON.parse(signin_data);

    console.log(data)

    const queryParams = {
      nivel_membresia: data.usuario.nivel_membresia, 
      tipo_usuario: data.usuario.tipo_usuario, 
      estatus:true, 
      fecha:"2024-10-24"
    }
    const response = await API.getCampaigns(queryParams)

    if(response.status == 200){
      
      setCampaign(response.data)
      console.log()
      await getQuizzes(response.data[0].firestore_id)
      await getRoulettes(response.data[0].firestore_id)
      await getPolls(response.data[0].firestore_id)

      setOpen(false)
    }else{

    }
  }

  React.useEffect(()=>{ 
    getCampaigns()
  },[])

  function onClickPollsButton(){
    navigate('/main/home/polls',{state:{data:polls}});
  }

  function onClickQuizzesButton(){
    navigate('/main/home/quizzes',{state:{data:quizzes}});
  }

  function onClickDynamicsButton(){
    navigate('/main/home/dynamics');
  }

  function onClickRoulettesButton(){
    navigate('/main/home/roulettes',{state:{data:roulettes}});
  }


  return (
    <Box sx={{ flexGrow: 1, overflow: 'hidden', px: 3, mt:8 }}>    
    <div sx={{ my: 1, mx: 'auto', p: 1 }}>
      <Grid container spacing={0} wrap="nowrap">
        <Grid item xs>
            <Stack spacing={2} sx={{width:"100%"}}>
              <Typography variant="h5" sx={{fontWeight:"bold"}}>Gana puntos con nuestras dinamicas</Typography>
              <Button sx={{textAlign:"left"}} variant="outlined" fullWidth color="secondary" endIcon={<ArrowForwardIosIcon /> } onClick={onClickDynamicsButton}>
                Realiza tu dinamica
              </Button>
            </Stack>
        </Grid>
      </Grid>
      
      <Grid container  alignItems="center" rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3}} sx={{ mt:2 }}>
        <Grid item xs={12}  container justify = "center" >
          <Stack spacing={2} sx={{width:"100%"}}>
              <Typography variant="body1"> Nos interesa saber lo que piensas.</Typography>
              <Button variant="contained" fullWidth color="secondary" endIcon={<ArrowForwardIosIcon /> } onClick={onClickPollsButton}>
                Realiza tu encuesta
              </Button>
          </Stack>
        </Grid>
      </Grid>

      <Grid container  alignItems="center" rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3}} sx={{ mt:2 }}>
        <Grid item xs={12}  container justify = "center" >
          <Stack spacing={2} sx={{width:"100%"}}>
              <Typography variant="body1"> Contesta nuestras trivias.</Typography>
              <Button variant="contained" fullWidth color="secondary" endIcon={<ArrowForwardIosIcon /> } onClick={ onClickQuizzesButton}>
               Trivias
              </Button>
              <Typography variant="h6" sx={{fontWeight:"bold"}}>¡Conoce nuestras promociones!</Typography>
          </Stack>
        </Grid>
      </Grid>

      <Grid container  alignItems="center" rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3}} sx={{ mt:2 }}>
        <Grid item xs={12}  container justify = "center" >
          <Stack spacing={2} sx={{width:"100%"}}>
              <Typography variant="body1">¡Prueba tu suerte! Gira la ruleta y gana increibles premios.</Typography>
              <Button variant="contained" fullWidth color="secondary" endIcon={<ArrowForwardIosIcon /> } onClick={ onClickRoulettesButton}>
               Comenzar
              </Button>
              <Typography variant="h6" sx={{fontWeight:"bold"}}>¡Conoce nuestras promociones!</Typography>
          </Stack>
        </Grid>
      </Grid>

      <Stack spacing={2} sx={{mt:8}}>
        <Carousel fullHeightHover={false} animation="slide" >
            {
                rows.map((row) => 
                <Card sx={{borderRadius:2}}> 
                <CardActionArea>
                    <CardMedia
                        component="img"
                        height="245px"
                        image= {row.imagen_url}
                        alt="banner"
                        />
                    
                </CardActionArea>
            </Card> )
            }
        </Carousel>
        <Typography align='left'>
          <Link href="https://firebasestorage.googleapis.com/v0/b/fir-820c7.appspot.com/o/Hojas%20de%20Venta%20AGOSTO%202024%20compress.pdf?alt=media&token=de11d767-b769-4948-95c9-ce8fa47cea16" variant="body2" color={"secondary"} >
            Descarga nuestro catalogo de promociones
          </Link>
        </Typography>
      </Stack>
    </div>
      <Backdrop
          sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
          open={open}
        >
          <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
}